export default __webpack_public_path__ + "static/media/contacthero.b68744fb.webp";